<template>
  <div>

    <form id="formSiteSetupLoginPage" @change="clearErrors()" class="d-flex flex-column" v-on:submit.prevent="updateLoginPageSettings">
      <div class="d-flex flex-column tab-card-form">
        <div class="element-info">
          <div class="row align-items-center">
            <div v-if="this.mobile" class="col-sm-8">
              <div class="element-info-with-icon justify-content-center">
                <div class="element-info-text text-center">
                  <h5 class="element-inner-header">Login Page</h5>
                  <div class="element-inner-desc">Here you can change the logo displayed on the login page.</div>
                </div>
              </div>
            </div>
            <div v-else class="col-sm-8">
              <div class="element-info-with-icon">
                <div class="element-info-icon">
                  <fontAwesomeIcon :icon="['fas', 'unlock-alt']" size="2x" />
                </div>
                <div class="element-info-text ml-5">
                  <h5 class="element-inner-header">Login Page</h5>
                  <div class="element-inner-desc">Here you can change the logo displayed on the login page.</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="project-box d-flex flex-column">
          <div class="project-head">
            <div class="project-title">
              <h5 v-if="!this.mobile" class="py-2 element-header">Upload new Login logo</h5>
              <h5 v-else class="py-2 text-center">Upload new Login logo</h5>
            </div>
          </div>
          <div class="row pb-2">
            <p v-if="!setupLoginPage.loginLogoImage || this.missingImage" class="mt-3 col-lg-6 col-sm-12">No logo has been uploaded</p>
            <div v-else class="col-lg-6 col-sm-12 image-container">
                <img v-if="!this.mobile" @error="imageError()" :src="setupLoginPage.loginLogoImage + '?' + this.cacheValue">
                <img v-else @error="imageError()" css="logo-mobile" :src="setupLoginPage.loginLogoImage + '?' + this.cacheValue" width="80%">
            </div>
            <b-form-group class="col-lg-6 col-sm-12 mt-0 align-self-start">
              <b-form-file
                id="login-logo"
                accept=".jpg, .png"
                v-model="inputLoginPage.loginLogoImage"
                placeholder="Choose a file or drop it here ..."
                drop-placeholder="Drop file here..."
              ></b-form-file>
              <div v-if="inputLoginPage.loginLogoImage && (typeof inputLoginPage.loginLogoImage == 'object') && (!Array.isArray(inputLoginPage.loginLogoImage))" class="mt-1 file-upload">
                <span v-if="inputLoginPage.loginLogoImage.name">
                  <fontAwesomeIcon :icon="['fas', 'file-image']" size="1x" />
                  <span class="pl-1"> {{ inputLoginPage.loginLogoImage.name }} </span>
                  <span v-if="inputLoginPage.loginLogoImage.size > 1000000" class="pl-2 text-danger">the file is too big ( {{ inputLoginPage.loginLogoImage.size }} bytes)</span>
                  <span v-else class="text-primary">selected</span>
                </span>
              </div>
            </b-form-group>
          </div>
          <div class="row pb-2">
            <p v-if="!setupLoginPage.loginBackgroundImage" class="mt-3 col-lg-6 col-sm-12">No background image has been uploaded</p>
            <div v-else class="col-lg-6 col-sm-12 image-container" id="background-image-container">
                <img id="background-img" v-if="!this.mobile" :src="setupLoginPage.loginBackgroundImage + '?' + this.cacheValue">
                <img id="background-img" v-else css="logo-mobile" :src="setupLoginPage.loginBackgroundImage + '?' + this.cacheValue" width="80%">
            </div>
            <b-form-group class="col-lg-6 col-sm-12 mt-0 align-self-start">
              <b-form-file
                id="login-background"
                accept=".jpg, .png"
                v-model="inputLoginPage.loginBackgroundImage"
                placeholder="Choose a file or drop it here ..."
                drop-placeholder="Drop file here..."
              ></b-form-file>
              <div v-if="inputLoginPage.loginBackgroundImage && (typeof inputLoginPage.loginBackgroundImage == 'object') && (!Array.isArray(inputLoginPage.loginBackgroundImage))" class="mt-1 file-upload">
                <span v-if="inputLoginPage.loginBackgroundImage.name">
                  <fontAwesomeIcon :icon="['fas', 'file-image']" size="1x" />
                  <span class="pl-1"> {{ inputLoginPage.loginBackgroundImage.name }} </span>
                  <span v-if="inputLoginPage.loginBackgroundImage.size > 4000000" class="pl-2 text-danger">the file is too big ( {{ inputLoginPage.loginBackgroundImage.size }} bytes)</span>
                  <span v-else class="text-primary">selected</span>
                </span>
              </div>
            </b-form-group>
          </div>
          <b-form-group class="mt-3 align-self-start">
            <b-input-group>
              <b-form-checkbox
                v-model="inputLoginPage.remove_logo_login"
                name="remove_logo_login"
                :value="1"
                :unchecked-value="0"
                class="mb-2">
                Remove Image
              </b-form-checkbox>
            </b-input-group>
          </b-form-group>
          <transition name="fade">
            <ResponseInfo  v-if="getResponseInfo.name == 'siteSetupLogin'" class="mt-3"/>
          </transition>
          <button v-if="!this.mobile" class="btn btn-primary mt-3 align-self-end" type="submit" value="submit">Update</button>
          <button v-else class="btn btn-secondary mt-3 align-self-end" type="submit" value="submit">Update</button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
/* The Layout input had been moved to the Appearance tab */
import { mapGetters } from 'vuex'
import ResponseInfo from '@/components/ResponseInfo.vue'
import ValidationErrors from '@/components/ValidationErrors.vue'

export default{
  name: 'SiteSetupLoginPage',
  components:{
    ResponseInfo,
    ValidationErrors
  },
  data() {
    return {
      setupLoginPage: {},
      inputLoginPage: {
        loginLogoImage: [],
        loginBackgroundImage: []
      },
      missingImage: false,
      cacheValue: new Date().getTime(),
      mobile: window.innerWidth <= 700
    }
  },
  created() {
    loginPageSettings:{
        this.$store.dispatch('getLoginPageSettings')
        .then(() => {
            if(Object.keys(this.loginPageSettings).length){
                this.setupLoginPage = Object.assign({}, this.loginPageSettings)
            }
        })
    }
    window.addEventListener('resize', () => {
          this.mobile = window.innerWidth <= 700
    })
  },
  computed:{
      ...mapGetters(['allTemplateDetails', 'getUserDetails','getIsNewsnet', 'getLoginPageSettings', 'getResponseInfo']),
      loginPageSettings:{
          get() {
              return this.$store.getters.getLoginPageSettings
          }
      }
  },
  methods: {
    update() {
      this.cacheValue = new Date().getTime()
    },
    imageError() {
      this.missingImage = true
    },
    clearErrors() {
      //clearing the error message when we change the input
      this.$store.commit('setValidationErrors', [])
    },
    updateLoginPageSettings(){
      //collecting the input data into a FormData object because we upload files
      let formData = new FormData()
      this.loginLogo = document.getElementById('login-logo').files[0]
      this.loginBackground = document.getElementById('login-background').files[0]

      if(this.loginLogo){
        formData.append('loginLogoImage', this.loginLogo)
      }
      if(this.loginBackground){
        formData.append('loginBackgroundImage', this.loginBackground)
      }
      formData.append('userId', this.getUserDetails.id)
      if(this.inputLoginPage.remove_logo_login == 1){
        formData.append('remove_logo_login', 1)
      }else{
        formData.append('remove_logo_login', 0)
      }

      this.$store.dispatch('setLoginPageSettings', formData)
      .then(
        setTimeout( () => {
          this.update()
          this.inputLoginPage.loginLogoImage = []
          this.inputLoginPage.loginBackgroundImage = []
          this.inputLoginPage.remove_logo_login = 0
          this.missingImage = false
        } , 500)
      )
    }
  }
}
</script>

<style lang="css" scoped>
.tab-card-form{
  min-width: 70%;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.image-container img{
  max-height: 120px;
}
#background-image-container{
  overflow: hidden;
}
.file-upload{
  border: 2px dashed lightgrey;
  padding: 5px;
}
</style>
